import React, { useEffect, useState } from "react";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import Loader from "../../components/Loader";
import RequestAccess from "../../components/requestAccess/RequestAccess";
import { getModuleAccessInfoApi } from "../../api/candidate";
import Utils from "../../utils/Utils";
import WebUtils from "../../utils/WebUtils";
import InSightMain from "../../components/insight/InSightMain";
import { ROLES } from "../../constants/UserRoles";
import OrgAdminStudentsMain from "../../components/orgAdmin/students/OrgAdminStudentsMain";

function OrgAdminStudents() {
  const [loading, setLoading] = useState(false);

  return (
    <>
      {loading && <Loader />}
      <div className="hirePlusPlusPageContent">
        <Sidebar activePage="students" userRole={ROLES.org_admin} />
        <div className="w-full hireplusplusRightContent">
          <Topbar
            activePage="students"
            userRole={ROLES.org_admin}
            newTitle="Students"
            noNavigate={true}
          />
          <OrgAdminStudentsMain setLoading={setLoading} />
        </div>
      </div>
    </>
  );
}

export default OrgAdminStudents;
